import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="max-w-3xl">
      <h2 className="text-3xl font-bold text-black mb-8">Datenschutzerklärung</h2>
      <div className="space-y-6 text-gray-700">
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">1. Datenschutz auf einen Blick</h3>
          <h4 className="font-semibold mb-2">Allgemeine Hinweise</h4>
          <p className="mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
            personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten
            sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>
          <h4 className="font-semibold mb-2">Datenerfassung auf dieser Website</h4>
          <p className="mb-4">
            <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
            Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser
            Datenschutzerklärung entnehmen.
          </p>
          <p className="mb-4">
            <strong>Wie erfassen wir Ihre Daten?</strong><br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es
            sich z. B. um Daten handeln, die Sie bei der Terminbuchung über Meetergo eingeben.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">2. Hosting</h3>
          <h4 className="font-semibold mb-2">Netlify</h4>
          <p className="mb-4">
            Wir hosten unsere Website bei Netlify. Anbieter ist die Netlify, Inc., 2325 3rd Street,
            Suite 296, San Francisco, CA 94107, USA (nachfolgend „Netlify").
          </p>
          <p className="mb-4">
            Wenn Sie unsere Website besuchen, erfasst Netlify verschiedene Logfiles inklusive Ihrer
            IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von Netlify:
            <a
              href="https://www.netlify.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-azure-600 hover:underline ml-1"
            >
              https://www.netlify.com/privacy/
            </a>
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">3. Terminbuchung über Meetergo</h3>
          <p className="mb-4">
            Für die Terminbuchung nutzen wir den Dienst Meetergo. Wenn Sie einen Termin buchen, werden
            Ihre Daten direkt an Meetergo übertragen und dort verarbeitet. Wir haben keinen Einfluss
            auf die Datenverarbeitung durch Meetergo.
          </p>
          <p className="mb-4">
            Details zur Datenverarbeitung durch Meetergo finden Sie in deren Datenschutzerklärung:
            <a
              href="https://meetergo.com/de/datenschutz/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-azure-600 hover:underline ml-1"
            >
              https://meetergo.com/de/datenschutz/
            </a>
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">4. Cookies und Tracking</h3>
          <p className="mb-4">
            Diese Website verwendet <strong>keine Cookies</strong> und{' '}
            <strong>keine Tracking-Tools</strong>. Wir verzichten bewusst auf jegliche Form der
            Nutzeranalyse oder des Trackings, um Ihre Privatsphäre zu schützen.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">5. Ihre Rechte</h3>
          <p className="mb-4">Sie haben jederzeit das Recht:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>
              Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten und deren Verarbeitung
              zu erhalten
            </li>
            <li>Berichtigung unrichtiger personenbezogener Daten zu verlangen</li>
            <li>Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
            <li>Einschränkung der Datenverarbeitung zu verlangen</li>
            <li>Widerspruch gegen die Verarbeitung Ihrer Daten bei uns einzulegen</li>
            <li>Datenübertragbarkeit zu verlangen</li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">6. Hinweis zur Verantwortlichen Stelle</h3>
          <p className="mb-4">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
          <p className="mb-4">
            Nadine Rau u. Mike Trepte GbR<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel<br />
            Telefon: 0561 / 43027276<br />
            E-Mail: mike.trepte@ki-kundenkommunikation.de
          </p>
          <p>
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
            gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen
            Daten entscheidet.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;